document.addEventListener('DOMContentLoaded', function() {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const progressBarFills = entry.target.querySelectorAll(
          '.progress-bar-fill'
        );
        progressBarFills.forEach(fill => {
          fill.style.transition = 'width 6s ease-in-out';
          fill.style.width = '95%';
        });

        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersection, options);

  const sections = document.querySelectorAll('.fibs-study-results');
  sections.forEach(section => {
    observer.observe(section);
  });
});
